import script from "./productDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./productDetails.vue?vue&type=script&setup=true&lang=js"

import "./productDetails.vue?vue&type=style&index=0&id=576a3559&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-576a3559"]])

export default __exports__